// extracted by mini-css-extract-plugin
export default {"l_HoverScreen_main":"HoverScreen_l_HoverScreen_main__sBC83","l_HoverScreen_icon_container":"HoverScreen_l_HoverScreen_icon_container__wMOb6"};